import Layout from '@/components/Layout';
import Terms from '@/components/Pages/Terms';

export default function TermsPage() {
  return (
    <Layout headerType={`float`}>
      <Terms></Terms>
    </Layout>
  );
}
